import { useQuery } from "@tanstack/react-query";

import { AccountController } from "../../api/accountController";

export function useAuthSettings(username?: string) {
	return useQuery({
		queryFn: () => AccountController.getSettings(username),
		queryKey: ["AuthSettings", username],
	});
}

export function useMfaTypes(username: string) {
	return useQuery({
		queryFn: () => AccountController.getMfaTypes(username),
		queryKey: ["MfaTypes", username],
		enabled: !!username,
	});
}
